import { AlertDialog, RootContainer } from "./widgets";
import { Typography } from "@mui/material";
import { defineMessage, FormattedMessage } from "react-intl";
import { Meeting } from "../types";
import { createUtcMoment } from "conference/tools";

export const getMeetingJoinTime = (meeting: Meeting) => createUtcMoment(meeting.startTime).subtract(15, "m").local();
export const getMeetingEndTime = (meeting: Meeting) =>
    createUtcMoment(meeting.startTime)
        .add(meeting.length + 60, "m")
        .local();

export const NotFoundError = () => (
    <RootContainer>
        <AlertDialog title={defineMessage({ id: "error.text", defaultMessage: "Error" })}>
            <Typography>
                <FormattedMessage id="meeting.notFound" defaultMessage="Meeting not found." />
            </Typography>
        </AlertDialog>
    </RootContainer>
);

export const meetingIsRunning = (meeting: Meeting) => {
    return getMeetingJoinTime(meeting).isBefore() && getMeetingEndTime(meeting).isAfter();
};
